import type { User } from 'oidc-client-ts';
import { isNil } from 'lodash';

import type { UserProfile } from '#packages/web/types/user-profile';

export const mapUserToUserProfile = (
  user?: User | null,
): UserProfile | undefined => {
  if (isNil(user)) {
    return undefined;
  }

  const fullName =
    `${user.profile.given_name} ${user.profile.family_name}`.trim();

  const avatarText = [user.profile.given_name, user.profile.family_name]
    .map((namePart) => namePart?.charAt(0).toUpperCase() ?? '')
    .join('')
    .trim();

  return {
    firstName: user.profile.given_name ?? '',
    lastName: user.profile.family_name ?? '',
    fullName: fullName,

    avatarText,
    email: user.profile.email ?? '',
  };
};
